import * as FEATURES from './features';
export const FEATURE_SHORT_LIMIT_MAP = {
  [FEATURES.ONE_TO_ONE_EMAIL]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.oneToOneEmail.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.oneToOneEmail.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.oneToOneEmail.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.oneToOneEmail.enterpriseTierLimit'
  },
  [FEATURES.CHANNEL_SWITCHING]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.channelSwitching.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.channelSwitching.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.channelSwitching.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.channelSwitching.enterpriseTierLimit'
  },
  [FEATURES.GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.enterpriseTierLimit'
  },
  [FEATURES.EMAIL_TRACKING_AND_NOTIFICATIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.enterpriseTierLimit'
  },
  [FEATURES.ONE_TO_ONE_VIDEO_MESSAGING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.oneToOneVideoMessaging.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.oneToOneVideoMessaging.enterpriseTierLimit'
  },
  [FEATURES.MULTIPLE_EMAIL_SIGNATURES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.multipleEmailSignatures.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.multipleEmailSignatures.enterpriseTierLimit'
  },
  [FEATURES.EMAIL_TEMPLATES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.emailTemplates.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.emailTemplates.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.emailTemplates.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.emailTemplates.enterpriseTierLimit'
  },
  [FEATURES.SALES_CONTENT_ANALYTICS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.salesContentAnalytics.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesContentAnalytics.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesContentAnalytics.enterpriseTierLimit'
  },
  [FEATURES.LIVE_CHAT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.liveChat.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.liveChat.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.liveChat.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.liveChat.enterpriseTierLimit'
  },
  [FEATURES.LOGGED_IN_VISITOR_IDENTIFICATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.loggedInVisitorIdentification.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.loggedInVisitorIdentification.enterpriseTierLimit'
  },
  [FEATURES.DRAGGABLE_CHAT_WIDGET]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.draggableChatWidget.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.draggableChatWidget.enterpriseTierLimit'
  },
  [FEATURES.CONVERSATIONAL_BOTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.conversationalBots.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.conversationalBots.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.conversationalBots.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.conversationalBots.enterpriseTierLimit'
  },
  [FEATURES.TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.ticketCreationLeadQualificationAndMeetingBookingBots.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.ticketCreationLeadQualificationAndMeetingBookingBots.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customBotsCustomBranchingLogicAndAdvancedTargeting.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customBotsCustomBranchingLogicAndAdvancedTargeting.enterpriseTierLimit'
  },
  [FEATURES.FACEBOOK_MESSENGER_INTEGRATION]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.enterpriseTierLimit'
  },
  [FEATURES.ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.advancedMessengerBotBranchingAndAdvancedReporting.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.advancedMessengerBotBranchingAndAdvancedReporting.enterpriseTierLimit'
  },
  [FEATURES.CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.codeSnippetsForCustomMessengerBotActions.enterpriseTierLimit'
  },
  [FEATURES.MEETING_SCHEDULER]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.meetingScheduler.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.meetingScheduler.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.meetingScheduler.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.meetingScheduler.enterpriseTierLimit'
  },
  [FEATURES.AI_MEETING_ASSISTANT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.aiMeetingAssistant.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.aiMeetingAssistant.enterpriseTierLimit'
  },
  [FEATURES.BOOK_ON_BEHALF_OF_OTHERS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.bookOnBehalfOfOthers.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.bookOnBehalfOfOthers.enterpriseTierLimit'
  },
  [FEATURES.LEAD_FORM_ROUTING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.leadFormRouting.enterpriseTierLimit'
  },
  [FEATURES.SHARED_INBOX]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.sharedInbox.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.sharedInbox.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.sharedInbox.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.sharedInbox.enterpriseTierLimit'
  },
  [FEATURES.CONVERSATION_ROUTING]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.conversationRouting.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.conversationRouting.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.conversationRouting.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_VIEWS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customViews.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customViews.enterpriseTierLimit'
  },
  [FEATURES.SNIPPETS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.snippets.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.snippets.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.snippets.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.snippets.enterpriseTierLimit'
  },
  [FEATURES.TASKS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.tasks.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.tasks.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.tasks.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.tasks.enterpriseTierLimit'
  },
  [FEATURES.TASK_CALENDAR_SYNC]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.taskCalendarSync.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.taskCalendarSync.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.taskCalendarSync.enterpriseTierLimit'
  },
  [FEATURES.REPEATING_TASKS_AND_QUEUES]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.repeatingTasksAndQueues.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.repeatingTasksAndQueues.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.repeatingTasksAndQueues.enterpriseTierLimit'
  },
  [FEATURES.CALLING]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.calling.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.calling.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.calling.enterpriseTierLimit'
  },
  [FEATURES.HUBSPOT_PROVIDED_PHONE_NUMBERS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.hubspotProvidedPhoneNumbers.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.hubspotProvidedPhoneNumbers.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.hubspotProvidedPhoneNumbers.enterpriseTierLimit'
  },
  [FEATURES.INTERACTIVE_VOICE_RESPONSE]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.interactiveVoiceResponse.enterpriseTierLimit'
  },
  [FEATURES.BREEZE_PROSPECTING_AGENT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.breezeProspectingAgent.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.breezeProspectingAgent.enterpriseTierLimit'
  },
  [FEATURES.LINKEDIN_SALES_NAVIGATOR_INTEGRATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.linkedinSalesNavigatorIntegration.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.linkedinSalesNavigatorIntegration.enterpriseTierLimit'
  },
  [FEATURES.SALES_WORKSPACE]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesWorkspace.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesWorkspace.enterpriseTierLimit'
  },
  [FEATURES.LEADS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.leads.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.leads.enterpriseTierLimit'
  },
  [FEATURES.GUIDED_ACTIONS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.guidedActions.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.guidedActions.enterpriseTierLimit'
  },
  [FEATURES.SEQUENCES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.sequences.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.sequences.enterpriseTierLimit'
  },
  [FEATURES.DYNAMIC_SEQUENCES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dynamicSequences.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dynamicSequences.enterpriseTierLimit'
  },
  [FEATURES.TARGET_ACCOUNTS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.targetAccounts.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.targetAccounts.enterpriseTierLimit'
  },
  [FEATURES.ABM_TOOLS_AND_AUTOMATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.abmToolsAndAutomation.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.abmToolsAndAutomation.enterpriseTierLimit'
  },
  [FEATURES.TARGET_ACCOUNTS_OVERVIEW]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.targetAccountsOverview.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.targetAccountsOverview.enterpriseTierLimit'
  },
  [FEATURES.BREEZE_COPILOT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.breezeCopilot.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.breezeCopilot.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.breezeCopilot.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.breezeCopilot.enterpriseTierLimit'
  },
  [FEATURES.DEALS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.deals.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.deals.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.deals.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.deals.enterpriseTierLimit'
  },
  [FEATURES.DEAL_PIPELINE_AUTOMATION]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.dealPipelineAutomation.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dealPipelineAutomation.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealPipelineAutomation.enterpriseTierLimit'
  },
  [FEATURES.DEAL_TAGS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.dealTags.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dealTags.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealTags.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_DEAL_TAG_RULES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customDealTagRules.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customDealTagRules.enterpriseTierLimit'
  },
  [FEATURES.DEAL_SUMMARIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dealSummaries.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealSummaries.enterpriseTierLimit'
  },
  [FEATURES.DEAL_SPLITS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealSplits.enterpriseTierLimit'
  },
  [FEATURES.DEAL_APPROVALS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealApprovals.enterpriseTierLimit'
  },
  [FEATURES.DOCUMENTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.documents.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.documents.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.documents.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.documents.enterpriseTierLimit'
  },
  [FEATURES.HUBSPOT_MOBILE_APP]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.hubspotMobileApp.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.hubspotMobileApp.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.hubspotMobileApp.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.hubspotMobileApp.enterpriseTierLimit'
  },
  [FEATURES.MOBILE_INBOX]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.mobileInbox.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.mobileInbox.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.mobileInbox.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.mobileInbox.enterpriseTierLimit'
  },
  [FEATURES.PAYMENTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.payments.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.payments.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.payments.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.payments.enterpriseTierLimit'
  },
  [FEATURES.STRIPE_PAYMENT_PROCESSING]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.enterpriseTierLimit'
  },
  [FEATURES.PAYMENT_LINKS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.paymentLinks.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.paymentLinks.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.paymentLinks.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.paymentLinks.enterpriseTierLimit'
  },
  [FEATURES.SUBSCRIPTIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.subscriptions.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.subscriptions.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.subscriptions.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.subscriptions.enterpriseTierLimit'
  },
  [FEATURES.B2B_CHECKOUT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.b2bCheckout.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.b2bCheckout.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.b2bCheckout.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.b2bCheckout.enterpriseTierLimit'
  },
  [FEATURES.QUOTES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.quotes.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.quotes.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.quotes.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.quotes.enterpriseTierLimit'
  },
  [FEATURES.E_SIGNATURE]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.eSignature.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.eSignature.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.eSignature.enterpriseTierLimit'
  },
  [FEATURES.INVOICES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.invoices.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.invoices.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.invoices.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.invoices.enterpriseTierLimit'
  },
  [FEATURES.REPORTING_DASHBOARDS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.reportingDashboards.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.reportingDashboards.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.reportingDashboards.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.reportingDashboards.enterpriseTierLimit'
  },
  [FEATURES.SALES_ANALYTICS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesAnalytics.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesAnalytics.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_REPORT_BUILDER]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customReportBuilder.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customReportBuilder.enterpriseTierLimit'
  },
  [FEATURES.DEAL_JOURNEY_ANALYTICS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealJourneyAnalytics.enterpriseTierLimit'
  },
  [FEATURES.PRODUCTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.products.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.products.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.products.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.products.enterpriseTierLimit'
  },
  [FEATURES.GOALS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.goals.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.goals.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.goals.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_GOALS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customGoals.enterpriseTierLimit'
  },
  [FEATURES.CONVERSATION_INTELLIGENCE]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.conversationIntelligence.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.conversationIntelligence.enterpriseTierLimit'
  },
  [FEATURES.COACHING_PLAYLISTS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.coachingPlaylists.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.coachingPlaylists.enterpriseTierLimit'
  },
  [FEATURES.TRACKED_TERMS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.trackedTerms.enterpriseTierLimit'
  },
  [FEATURES.FORECASTING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.forecasting.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.forecasting.enterpriseTierLimit'
  },
  [FEATURES.FORECAST_ACROSS_TEAM_HIERARCHIES]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.forecastAcrossTeamHierarchies.enterpriseTierLimit'
  },
  [FEATURES.AI_FORECASTING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.aiForecasting.enterpriseTierLimit'
  },
  [FEATURES.PLAYBOOKS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.playbooks.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.playbooks.enterpriseTierLimit'
  },
  [FEATURES.EMBED_AND_UPDATE_PROPERTIES]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.embedAndUpdateProperties.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_PROPERTIES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.customProperties.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.customProperties.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customProperties.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customProperties.enterpriseTierLimit'
  },
  [FEATURES.CALCULATED_PROPERTIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.calculatedProperties.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.calculatedProperties.enterpriseTierLimit'
  },
  [FEATURES.SYNC_PROPERTIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.syncProperties.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.syncProperties.enterpriseTierLimit'
  },
  [FEATURES.SCORE_PROPERTIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.scoreProperties.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.scoreProperties.enterpriseTierLimit'
  },
  [FEATURES.PREDICTIVE_LEAD_SCORING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.predictiveLeadScoring.enterpriseTierLimit'
  },
  [FEATURES.FIELD_LEVEL_PERMISSIONS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.fieldLevelPermissions.enterpriseTierLimit'
  },
  [FEATURES.DATA_MODEL]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.dataModel.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.dataModel.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dataModel.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dataModel.enterpriseTierLimit'
  },
  [FEATURES.ASSOCIATION_LABELS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.associationLabels.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.associationLabels.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_USER_PERMISSIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.customUserPermissions.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.customUserPermissions.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customUserPermissions.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customUserPermissions.enterpriseTierLimit'
  },
  [FEATURES.PERMISSION_SETS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.permissionSets.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.permissionSets.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.permissionSets.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_PERMISSION_SETS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customPermissionSets.enterpriseTierLimit'
  },
  [FEATURES.SLACK_INTEGRATION]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.slackIntegration.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.slackIntegration.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.slackIntegration.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.slackIntegration.enterpriseTierLimit'
  },
  [FEATURES.USER_MANAGEMENT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.userManagement.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.userManagement.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.userManagement.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.userManagement.enterpriseTierLimit'
  },
  [FEATURES.TEAMS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.teams.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.teams.enterpriseTierLimit'
  },
  [FEATURES.PRESETS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.presets.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.presets.enterpriseTierLimit'
  },
  [FEATURES.ORGANIZE_TEAMS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.organizeTeams.enterpriseTierLimit'
  },
  [FEATURES.LOG_IN_AS_ANOTHER_USER]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.logInAsAnotherUser.enterpriseTierLimit'
  },
  [FEATURES.SINGLE_SIGN_ON]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.singleSignOn.enterpriseTierLimit'
  },
  [FEATURES.ONE_TO_ONE_TECHNICAL_SUPPORT]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.oneToOneTechnicalSupport.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.oneToOneTechnicalSupport.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.oneToOneTechnicalSupport.enterpriseTierLimit'
  },
  [FEATURES.EMAIL_AND_IN_APP_CHAT]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.emailAndInAppChat.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.emailAndInAppChat.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.emailAndInAppChat.enterpriseTierLimit'
  },
  [FEATURES.PHONE_SUPPORT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.phoneSupport.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.phoneSupport.enterpriseTierLimit'
  },
  [FEATURES.LISTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.lists.freeTierLimit',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.lists.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.lists.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.lists.enterpriseTierLimit'
  },
  [FEATURES.ADVANCED_LIST_CRITERIA]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.advancedListCriteria.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.advancedListCriteria.enterpriseTierLimit'
  },
  [FEATURES.MULTIPLE_CURRENCIES]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.multipleCurrencies.starterTierLimit',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.multipleCurrencies.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.multipleCurrencies.enterpriseTierLimit'
  },
  [FEATURES.DUPLICATE_MANAGEMENT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.duplicateManagement.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.duplicateManagement.enterpriseTierLimit'
  },
  [FEATURES.LINKEDIN_CRM_SYNC_INTEGRATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.linkedinCrmSyncIntegration.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.linkedinCrmSyncIntegration.enterpriseTierLimit'
  },
  [FEATURES.SALES_EMAIL_FREQUENCY_CONTROLS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesEmailFrequencyControls.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesEmailFrequencyControls.enterpriseTierLimit'
  },
  [FEATURES.SALESFORCE_INTEGRATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesforceIntegration.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesforceIntegration.enterpriseTierLimit'
  },
  [FEATURES.SALESFORCE_CUSTOM_OBJECT_SYNC]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesforceCustomObjectSync.enterpriseTierLimit'
  },
  [FEATURES.WORKFLOWS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.workflows.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.workflows.enterpriseTierLimit'
  },
  [FEATURES.WORKFLOW_EXTENSIONS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.workflowExtensions.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.workflowExtensions.enterpriseTierLimit'
  },
  [FEATURES.AUTOMATIC_LEAD_ROTATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.automaticLeadRotation.professionalTierLimit',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.automaticLeadRotation.enterpriseTierLimit'
  },
  [FEATURES.TRIGGER_SEQUENCES]: {},
  // Empty as per source data
  [FEATURES.WORKFLOW_HEALTH_MONITORING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.workflowHealthMonitoring.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_EVENTS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customEvents.enterpriseTierLimit'
  },
  [FEATURES.CUSTOM_OBJECTS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customObjects.enterpriseTierLimit'
  },
  [FEATURES.SENSITIVE_DATA]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.sensitiveData.enterpriseTierLimit'
  },
  [FEATURES.STANDARD_SANDBOX_ACCOUNT]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.standardSandboxAccount.enterpriseTierLimit'
  }
};